import { Routes } from '@angular/router';
import { CreditoHomeComponent } from './features-credits/home/home.component';
import { MedicalEquipmentLeasingHomeComponent } from './features-medical-equipment-leasing/home/home.component';
import { VisitasService } from './core/services/visitas.service';

export const routes: Routes = [
  { path: '', redirectTo: 'credito', pathMatch: 'full' },

  {
    path: 'credito',
    title: 'Crédito',
    providers: [VisitasService],
    children: [
      { path: '', redirectTo: 'home', pathMatch: 'full' },
      { path: 'home', component: CreditoHomeComponent },
      {
        path: 'user-info',
        loadChildren: () =>
          import('./features-credits/features/identity-verification/identity-verification.routes').then(
            (m) => m.routes,
          ),
      },
      {
        path: 'adout-user',
        loadChildren: () =>
          import('./features-credits/features/credit-application/credit-application.routes').then(
            (m) => m.routes,
          ),
      },
      {
        path: 'address-validation',
        loadChildren: () =>
          import('./features-credits/features/address-verification/address-verification.routes').then(
            (m) => m.routes,
          ),
      },
    ],
  },

  {
    path: 'asset-management',
    title: 'Gestión de Activos',
    providers: [VisitasService],
    children: [
      { path: '', redirectTo: 'home', pathMatch: 'full' },
      { path: 'home', component: MedicalEquipmentLeasingHomeComponent },
      {
        path: 'user-info',
        loadChildren: () =>
          import('./features-medical-equipment-leasing/features/identity-verification/identity-verification.routes').then(
            (m) => m.routes,
          ),
      },
      {
        path: 'adout-user',
        loadChildren: () =>
          import('./features-medical-equipment-leasing/features/asset-questionnaire/asset-questionnaire.routes').then(
            (m) => m.routes,
          ),
      },
      {
        path: 'address-validation',
        loadChildren: () =>
          import('./features-medical-equipment-leasing/features/ticket-closing/ticket-closing.routes').then(
            (m) => m.routes,
          ),
      },
    ],
  },

  { path: '**', redirectTo: 'credito' },
];
